import styles from './DisputeInput.module.scss';
import type { DisputeInputProps } from './DisputeInput.types';

export const DisputeInput = ({
  register,
  title = 'Комментарий',
  placeholder = 'Введите комментарий',
  type = 'text',
  value,
}: DisputeInputProps) => {
  return (
    <div className={styles.disputeCardInput}>
      <label>{title}</label>
      <input type={type} placeholder={placeholder} value={value} {...register} />
    </div>
  );
};
